import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { services } from '../data/mock';
import ServiceModal from './ServiceModal';

const ServicesSection = () => {
  const [selectedService, setSelectedService] = useState(null);

  const getIcon = (iconName) => {
    const Icon = LucideIcons[iconName];
    return Icon ? <Icon size={32} /> : <LucideIcons.Leaf size={32} />;
  };

  return (
    <section id="services" className="section-padding bg-[#F5F9E8]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#2D5A4A] font-semibold text-sm uppercase tracking-wider">
            What We Offer
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B3A3A] mt-3 mb-6">
            Our Professional Services
          </h2>
          <p className="text-lg text-[#6B7B7B]">
            From irrigation systems to landscape lighting, we provide comprehensive
            landscaping solutions for residential and commercial properties.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="service-card hover-lift"
              onClick={() => setSelectedService(service)}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="relative overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="service-card-image"
                  loading="lazy"
                />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-3 text-[#1B3A3A]">
                  {getIcon(service.icon)}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#1B3A3A] mb-2">
                  {service.title}
                </h3>
                <p className="text-[#6B7B7B] text-sm mb-4">
                  {service.shortDesc}
                </p>
                <button className="text-[#2D5A4A] font-semibold text-sm flex items-center gap-2 hover:gap-3 transition-all">
                  View Details
                  <LucideIcons.ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Service Modal */}
      {selectedService && (
        <ServiceModal
          service={selectedService}
          onClose={() => setSelectedService(null)}
        />
      )}
    </section>
  );
};

export default ServicesSection;
